import GateVertexValue from "../GateVertexValue";
import Label from "../../../HCLTreeVertexValue/Label";
import Formula from "../../../HCLTreeVertexValue/Formula";
import ProxyType from "../../../HCLTreeVertexValue/ProxyTypes";
import GateTypes, {GateTypeDescriptions} from "../../../HCLTreeVertexValue/GateTypes";

class CARDINALITYGateVertexValue extends GateVertexValue {
  constructor(label?: Label, formula?: Formula) {
    super(
      label || new Label(GateTypeDescriptions[GateTypes.CARDINALITY], ""),
      formula || new Formula({ _proxy: ProxyType.LOGICAL_EXPRESSION, expr: GateTypes.CARDINALITY })
    )
  }

  clone(): CARDINALITYGateVertexValue {
    return new CARDINALITYGateVertexValue(this.label.clone(), this.formula.clone());
  }
}

export default CARDINALITYGateVertexValue;
